import states from './live-map.states'
import getters from './live-map.getters'
import mutations from './live-map.mutations'
import actions from './live-map.actions'

export default {
  namespaced: true,
  state: states,
  getters,
  mutations,
  actions,
}
